<template>
  <div id="shipping-address">
    <div v-for="(address, index) in shippingAddress" :key="index" class="row">
      <div class="form-group col-md-12">
        <label for="" class="control-label">Shipping Contact {{index > 0 ? index + 1 : null}}:</label>
        <label v-show="shippingAddress.length > 1" @click="removeShippingAddress(index)" class="text-danger pointer ml-2">
          Delete
          <span class="fa fa-trash fa-lg"></span>
        </label>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'shippingFirstName-'+index" class="control-label required">First Name</label>
          <input
            :id="'shippingFirstName-'+index"
            v-model.trim="address.firstName"
            :name="'shippingFirstName-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].firstName.$touch()"
          />
          <div
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].firstName.required &&
              v.company.companyLocation.shippingAddress.$each[index].firstName.$error
            "
            class="text-danger"
          >
            Please enter valid First Name
          </div>
          <div
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].firstName.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].firstName.$error
            "
            class="text-danger"
          >
            Allowed upto 100 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'shippingMiddleName-'+index" class="control-label">Middle Name</label>
          <input
            :id="'shippingMiddleName-'+index"
            v-model.trim="address.middleName"
            :name="'shippingMiddleName-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].middleName.$touch()"
          />
          <div
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].middleName.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].middleName.$error
            "
            class="text-danger"
          >
            Allowed upto 100 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'shippingLastName-'+index" class="control-label required">Last Name</label>
          <input
            :id="'shippingLastName-'+index"
            v-model.trim="address.lastName"
            :name="'shippingLastName-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].lastName.$touch()"
          />
          <div
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].lastName.required &&
              v.company.companyLocation.shippingAddress.$each[index].lastName.$error
            "
            class="text-danger"
          >
            Please enter valid Last Name
          </div>
          <div
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].lastName.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].lastName.$error
            "
            class="text-danger"
          >
            Allowed upto 100 characters only
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'shippingEmail-'+index" class="control-label required">Email Address</label>
          <input
            :id="'shippingEmail-'+index"
            v-model.trim="address.emailAddress"
            :name="'shippingEmail-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].emailAddress.$touch()"
          />
          <div
            v-if="
              (!v.company.companyLocation.shippingAddress.$each[index].emailAddress.required ||
                !v.company.companyLocation.shippingAddress.$each[index].emailAddress.email) &&
              v.company.companyLocation.shippingAddress.$each[index].emailAddress.$error
            "
            class="text-danger"
          >
            Please enter valid email address
          </div>
          <div
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].emailAddress.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].emailAddress.$error
            "
            class="text-danger"
          >
            Allowed upto 150 characters only.
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'shippingPhoneNumber-'+index" class="control-label required">Phone Number</label>
          <input
            :id="'shippingPhoneNumber-'+index"
            v-model.trim="address.phoneNumber"
            :name="'shippingPhoneNumber-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].phoneNumber.$touch()"
          />
          <div
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].phoneNumber.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].phoneNumber.$error
            "
            class="text-danger"
          >
            Allowed upto 15 characters only
          </div>
          <div
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].phoneNumber.required &&
              v.company.companyLocation.shippingAddress.$each[index].phoneNumber.$error
            "
            class="text-danger"
          >
            Please enter valid phone number
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'shippingJobTitle-'+index" class="control-label required">Job Title</label>
          <input
            :id="'shippingJobTitle-'+index"
            v-model.trim="address.jobTitle"
            :name="'shippingJobTitle-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].jobTitle.$touch()"
          />
          <div
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].jobTitle.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].jobTitle.$error
            "
            class="text-danger"
          >
            Allowed upto 200 characters only
          </div>
          <div
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].jobTitle.required &&
              v.company.companyLocation.shippingAddress.$each[index].jobTitle.$error
            "
            class="text-danger"
          >
            Please enter valid job title
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'shippingAddressLine1-'+index" class="control-label required">Shipping Address {{index > 0 ? index + 1 : null}} Line 1</label>
          <input
            :id="'shippingAddressLine1-'+index"
            v-model.trim="address.line1"
            :name="'shippingAddressLine1-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].line1.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].line1.required &&
              v.company.companyLocation.shippingAddress.$each[index].line1.$error
            "
          >
            Please enter shipping address {{index > 0 ? index + 1 : null}} line 1
          </div>
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].line1.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].line1.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'shipppingCity-'+index" class="control-label required">City</label>
          <input
            :id="'shipppingCity-'+index"
            v-model.trim="address.city"
            :name="'shipppingCity-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].city.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].city.required &&
              v.company.companyLocation.shippingAddress.$each[index].city.$error
            "
          >
            Please enter city
          </div>
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].city.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].city.$error
            "
          >
            Allowed upto 100 characters only
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'shippingAddressLine2-'+index" class="control-label">Shipping Address {{index > 0 ? index + 1 : null}} Line 2</label>
          <input
            :id="'shippingAddressLine2-'+index"
            v-model.trim="address.line2"
            :name="'shippingAddressLine2-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].line2.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].line2.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].line2.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'shippingCountry-'+index" class="control-label required">Country</label>
          <select
            :id="'shippingCountry-'+index"
            v-model="address.country"
            :name="'shippingCountry-'+index"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].country.$touch()"
            @change="countryChanged(index)"
          >
            <option value="">Select Country</option>
            <option v-for="country in countries" :key="country.cntryId" :value="country.cntryId">
              {{ country.cntryNm }}
            </option>
          </select>
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].country.required &&
              v.company.companyLocation.shippingAddress.$each[index].country.$error
            "
          >
            Please select country
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'shippingAddressLine3-'+index" class="control-label">Shipping Address {{index > 0 ? index + 1 : null}} Line 3</label>
          <input
            :id="'shippingAddressLine3-'+index"
            v-model.trim="address.line3"
            :name="'shippingAddressLine3-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].line3.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].line3.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].line3.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'shippingState-'+index" class="control-label required">State/Province/Region</label>
          <input
            :id="'shippingState-'+index"
            v-model.trim="address.state"
            :name="'shippingState-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].state.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].state.required &&
              v.company.companyLocation.shippingAddress.$each[index].state.$error
            "
          >
            Please enter state/province/region
          </div>
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].state.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].state.$error
            "
          >
            Allowed upto 100 characters only
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'shippingAddressLine4-'+index" class="control-label">Shipping Address {{index > 0 ? index + 1 : null}} Line 4</label>
          <input
            :id="'shippingAddressLine4-'+index"
            v-model.trim="address.line4"
            :name="'shippingAddressLine4-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].line4.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].line4.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].line4.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'shippingZipCode-'+index" class="control-label required">Zip/Postal Code</label>
          <input
            :id="'shippingZipCode-'+index"
            v-model.trim="address.zipCode"
            :name="'shippingZipCode-'+index"
            type="text"
            class="form-control"
            @blur="v.company.companyLocation.shippingAddress.$each[index].zipCode.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].zipCode.required &&
              v.company.companyLocation.shippingAddress.$each[index].zipCode.$error
            "
          >
            Please enter zip/postal code
          </div>
          <div
            class="text-danger"
            v-if="
              !v.company.companyLocation.shippingAddress.$each[index].zipCode.maxLength &&
              v.company.companyLocation.shippingAddress.$each[index].zipCode.$error
            "
          >
            Allowed upto 20 characters only
          </div>
        </div>
      </div>
      <div v-if="!v.company.shippingAddressSame" class="row form-group col-md-12">
        <carrier-details :address = address :index = index @carrierDetailsStatus="carrierDetailsStatus"/>
      </div>
      <div v-show="shippingAddress.length > 1 && index < shippingAddress.length-1" class="form-group col-md-11 divider">
      </div>
    </div>
    <div v-if="error" class="text-danger">Please fill all the valid details</div>
    <div v-if="maxCountError" class="text-danger">Allowed upto 5 addresses only</div>
    <div class="mt-1">
      <button id="add-new-row" class="btn btn-xs btn-primary" @click="addShippingAddress">
        <i class="fa fa-plus-circle"></i> Add Address
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import carrierDetails from "@/mycfm/components/new-company/CarrierDetails";
import { CarrierDetails } from "@/model/CarrierDetails";

export default {
  components: {
    carrierDetails
  },
  props: {
    v: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      maxCountError: false,
      invalidCarrierDetails: false,
      carrierDetailsValidation: []
    };
  },
  computed: {
    ...mapState("country", ["countries"]),
    ...mapState("company", ["company"]),
    shippingAddress() {
      return this.$store.state.company.company.companyLocation.shippingAddress;
    },
    error() {
      return this.v.company.companyLocation.shippingAddress.$error || this.invalidCarrierDetails;
    },
  },
  methods: {
    addShippingAddress: function () {
      this.v.company.companyLocation.shippingAddress.$touch();
      if (this.v.company.companyLocation.shippingAddress.$invalid || this.invalidCarrierDetails) {
        return;
      } else if (this.shippingAddress && this.shippingAddress.length >= 5) {
        this.maxCountError = true;
        return;
      } else {
        this.v.company.companyLocation.shippingAddress.$reset();
        this.$store.dispatch("company/addShippingAddress");
      }
    },
    removeShippingAddress(index) {
      this.$store.dispatch("company/removeShippingAddress", index);
      this.carrierDetailsValidation.splice(index,1)
      this.invalidCarrierDetails = this.carrierDetailsValidation.some(x=> x == true) ? true : false;
      this.$emit("shippingCarrierDetailsStatus", this.invalidCarrierDetails)
      this.maxCountError = false;
    },
    //keep track of carrier details is vaild or not
    carrierDetailsStatus(object) {
      this.carrierDetailsValidation[object.index] = object.status
      this.invalidCarrierDetails = this.carrierDetailsValidation.some(x=> x == true) ? true : false;
      this.$emit("shippingCarrierDetailsStatus", this.invalidCarrierDetails)
    },
    countryChanged(index) {
      this.$store.state.company.company.companyLocation.shippingAddress[index].carrierDetails = new CarrierDetails()
    }
  },
};
</script>
<style lang="less" scoped>
.ship-radio-btns {
  padding-left: 10px;
  .radio-inline {
    margin-right: 15px;
    input[type="radio"] {
      cursor: pointer;
    }
    span {
      vertical-align: middle;
    }
  }
}
.ml-2{
  margin-left: 8px;
}
.mt-1{
  margin-top: 4px;
}
.divider {
  height: 1px;
  overflow: hidden;
  background-color: #DDE4E8;
  margin-left: 15px;
}
</style>
